<template>
  <!--BEGIN-->
  <b-row class="m-2 hider">
    <b-col>
      <div class="mb-1 mt-1">
        <span v-if="isMinimized" @click="apply('NOT_MINIMIZED')" class="mr-3 hand text-primary">
          <i class="fa fa-check-circle"></i>
          {{ $t("minimization.status.minimized") }}
        </span>
        <span v-else @click="apply('MINIMIZED')" class="hand">
          <i class="fa fa-circle"></i>
          {{ $t("minimization.status.not-minimized") }}
        </span>
      </div>
      <div v-if="hasApprovalDetailView() && minimization">
        {{ minimization.sentAt }}
        <div v-if="minimization.sentAt">
          <h6 class="mt-2">{{ $t("minimization.minimization-detail") }}</h6>
          <span v-if="minimization.sentBy" class="mr-2">
            <i class="fa fa-user"></i>
            {{ minimization.sentBy.name }}
          </span>
          <span v-if="minimization.sentAt" v-b-tooltip.hover :title="$t('minimization.update-time')">
            <i class="fa fa-clock"></i>
            {{ minimization.sentAt | date(true) }}
          </span>
        </div>
        <div v-if="minimization.approved">
          <h6 class="mt-2">{{ $t("minimization.approval-detail") }}</h6>
          <span v-if="minimization.approvedBy" class="mr-2">
            <i class="fa fa-user"></i>
            {{ minimization.approvedBy.name }}
          </span>
          <span v-if="minimization.approvedAt" v-b-tooltip.hover :title="$t('minimization.update-time')">
            <i class="fa fa-clock"></i>
            {{ minimization.approvedAt | date(true) }}
          </span>
        </div>

        <div v-if="hasApprovePermission() && !minimization.approved" class="mt-1">
          <span @click="approve()" class="text-primary hand">
            <i class="fa fa-check-circle  "></i>
            {{ $t("minimization.approve") }}
          </span>
        </div>

        <div v-if="minimization.approved" class="text-success">
          <i class="fa fa-info-circle"></i>
          {{ $t("minimization.collect.approved") }}
        </div>
      </div>
    </b-col>
  </b-row>

  <!--END-->
</template>

<script>
export default {
  props: ["department", "process", "datasubject", "thirdParty"],
  computed: {
    minimization() {
      return this.datasubject.feature?.minimization;
    },

    isMinimized() {
      return this.minimization?.status == "MINIMIZED";
    },
  },
  methods: {
    async apply(status) {
      const response = await this.$store.dispatch("minimization/updateDatasubjectTransferMinimization", {
        id: this.datasubject._id,
        organizationThirdPartyId: this.thirdParty._id,
        status,
      });
      this.$emit("onSave");
    },

    async approve() {
      const response = await this.$store.dispatch("minimization/approveDatasubjectTransferMinimization", {
        id: this.datasubject._id,
        organizationThirdPartyId: this.thirdParty._id,
      });

      this.$emit("onSave");
    },

    hasApprovePermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_GDPR_PRODUCT_ADMIN", "ORGANIZATION_KVKK_PRODUCT_ADMIN", "ORGANIZATION_LEGAL_ADMIN"])) {
        return true;
      }

      if (this.department.admins.find((a) => a._id == this.currentAccount._id) || this.process.admins.find((a) => a._id == this.currentAccount._id)) {
        return true;
      }

      return false;
    },
    hasApprovalDetailView() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      if (this.department.admins.find((a) => a._id == this.currentAccount._id) || this.process.admins.find((a) => a._id == this.currentAccount._id)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
h6 {
  font-size: 10px;
  margin: 0px;
  color: gray;
}
</style>
